import React from 'react';
import { Link } from 'react-router-dom';

// CTA block — internal conversion links (first = primary, rest = secondary). Presentation only.
// Links are internal paths (validated build-time). Mirrors the pre-migration service-page CTAs.
export default function Cta({ heading, text, actions }) {
  return (
    <div className="mb-10">
      {heading ? (
        <h2 className="mb-3 font-heading text-2xl font-bold text-black">{heading}</h2>
      ) : null}
      {text ? <p className="mb-6 max-w-2xl text-neutral-600">{text}</p> : null}
      <div className="flex flex-wrap gap-4">
        {actions.map((a, i) => (
          <Link
            key={`${a.to}-${i}`}
            to={a.to}
            className={
              i === 0
                ? 'rounded-md bg-black px-6 py-3 text-sm font-medium text-white hover:bg-neutral-800'
                : 'rounded-md border border-neutral-300 px-6 py-3 text-sm text-neutral-700 hover:bg-white'
            }
          >
            {a.label}
          </Link>
        ))}
      </div>
    </div>
  );
}
